import { render, staticRenderFns } from "./Treportable.vue?vue&type=template&id=a35d18fe&scoped=true"
import script from "./Treportable.vue?vue&type=script&lang=js"
export * from "./Treportable.vue?vue&type=script&lang=js"
import style0 from "./Treportable.vue?vue&type=style&index=0&id=a35d18fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d18fe",
  null
  
)

export default component.exports